import moment from 'moment';

/**
 * Formats a date string to the specified format (Default: MM/DD/YYYY, h am/pm format)
 * @param {string} dateString - The date string to format (e.g. "2025-04-28T07:00:00")
 * Takes UTC datetime and converts to local time.
 * @param {string} format - The format string for moment.js (default: 'MM/DD/YYYY, h a')
 * @returns {string} The formatted date string (e.g. "04/28/2025, 7 am")
 */
export const formatDate = (dateString, format = 'MM/DD/YYYY, h a') => {
  if (!dateString || dateString === 'null' || dateString === 'undefined') {
    return '';
  }

  const localDate = moment.utc(dateString).local();

  if (!localDate.isValid()) {
    return '';
  }

  return localDate.format(format);
};
